import { faBackward, faRefresh, faSignOut, faUserEdit } from "@fortawesome/free-solid-svg-icons"
import { useDispatch, useSelector } from "react-redux"
import { Link, useLocation, useNavigate } from "react-router-dom"
import useFetch from "../hook/useFetch"
import { userActions } from "../store/user-slice"
import InfoIcon from "./InfoIcon"

export default function Header() {
    const { update } = useFetch()
    let user = useSelector(state => state.user.user)

    let dispatch = useDispatch()
    let navigate = useNavigate()
    let isAdmin = useSelector(state => state.user.isAdmin)

let location=useLocation()


    return <header className="header" style={{ backgroundColor: 'whitesmoke', display: 'flex', padding: 10, justifyContent: 'space-between' }} >
        <div style={{ display: 'flex', justifyContent: 'flex-start' }} >
            <button type="button" className="btn btn-secondary"  onClick={() => {
                navigate(-1)
            }} ><InfoIcon icon={faBackward} /> Return</button>
           
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-start' }} >
        <button type="button" className="btn btn-outline-secondary" onClick={() => {
                navigate(location.pathname,{state:{
                    refetch:true
                }})
            }} ><InfoIcon icon={faRefresh} /> Refresh</button>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }} >
            {user && <div style={{ marginRight: 20, display: 'flex', justifyContent: 'center', height: '100%', alignItems: 'center' }} ><Link to={isAdmin ? '/admin/profile' : '/profile'}  ><InfoIcon size='xl' title='profile' icon={faUserEdit} />Hallo {user.username}</Link></div>}
            <button className="btn btn-outline-secondary" type="button" onClick={() => {
                update('/user/logout', {
                    email: user.email
                }, null, () => {
                    dispatch(userActions.setUser(null))
                    dispatch(userActions.setToken(null))
                    navigate('/')
                })
            }} ><InfoIcon icon={faSignOut} />Logout</button>
        </div>


    </header>
}